module.exports = __webpack_public_path__ + "static/bonduelle-080c4b510bf414a5741e76f65de46ef5.png";